@import '../../utils/choice-list.css';
@import '../../utils/control-parts.css';
@import '../../utils/control-width.css';
@import '../../utils/field-stack.css';
@import '../../utils/search-control.css';
@import '../../utils/select-trigger.css';
@import '../../utils/table-caption-control.css';
@import '../../utils/typography.css';
@import '../../styles/control-elevation.css';

.wrapper--error {
  --ds-interaction-border-width: var(--dimension-stroke-width-018);
  --ds-interaction-border-color: var(--color-border-bold-negative);
}

.select-popup {
  color: var(--color-foreground-secondary);
}

.select-option[aria-selected='true'] .ds-choice-item__icon {
  color: var(--color-foreground-primary);
}

.select-option-row {
  position: relative;
  isolation: isolate;
}

.select-option-row__action {
  position: absolute;
  top: 50%;
  right: var(--dimension-space-050);
  z-index: var(--dimension-z-index-floating);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--dimension-radius-half);
  background: var(--color-background-transparent);
  -webkit-backdrop-filter: blur(var(--effect-blur-sm));
  backdrop-filter: blur(var(--effect-blur-sm));
  opacity: 0;
  pointer-events: none;
  transform: translateY(-50%);
}

.select-option-row:has(:focus-visible) .select-option-row__action,
.select-option-row--action-open .select-option-row__action,
.select-option-row--keyboard-active .select-option-row__action {
  opacity: 1;
  pointer-events: auto;
}

.select-option-row--action-open .select-option::after {
  background: var(--ds-interaction-hover);
}

.select-option__subtext-actions {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-050);
  min-inline-size: 0;
  color: var(--color-foreground-secondary);
}

.select-option__subtext-action {
  appearance: none;
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: 0;
  border-radius: var(--dimension-radius-025);
  background: transparent;
  cursor: pointer;
}

.select-option__subtext-action--negative {
  --ds-text-action-foreground: var(--color-foreground-bold-negative);
}

.select-option__subtext-action-separator {
  color: var(--color-foreground-tertiary);
  pointer-events: none;
}

@media (hover: hover) and (pointer: fine) {
  .select-option-row:hover .select-option-row__action {
    opacity: 1;
    pointer-events: auto;
  }

  .select-option-row:hover .select-option::after {
    background: var(--ds-interaction-hover);
  }
}

@media (hover: none) {
  .select-option-row__action {
    opacity: 1;
    pointer-events: auto;
  }

  .select-option-row--has-action .ds-choice-item__content {
    padding-inline-end: var(--dimension-size-400);
  }
}

.error-text {
  width: 100%;
}
